<template>
  <v-card class="mx-4 my-8 rounded-xl bb-br-4" elevation="0">
    <v-row class="no-gutters pos-rel">
      <v-col class="col-12 col-md-2">
        <v-card-text class="text-center">
          <v-img
            v-if="lastGreeting.byUserImage"
            class="user-profile-image mx-auto"
            aspect-ratio="1"
            alt="User Image"
            :src="lastGreeting.byUserImage"
            :lazy-src="require('../../assets/images/lazy-loading.png')"
          ></v-img>
          <div v-else>
            <div class="user-profile-image mx-auto">
              <span>
                {{
                  getUserInitials(
                    lastGreeting.byUserFullName.split(" ")[0],
                    lastGreeting.byUserFullName.split(" ")[1]
                  )
                }}</span
              >
            </div>
          </div>
          <h3 class="black--text">
            {{ `${lastGreeting.byUserFullName}` }}
          </h3>
          <p class="caption mb-0 font-weight-bold grey--text">
            {{ getDate(lastGreeting) }}
          </p>
        </v-card-text>
      </v-col>
      <v-col class="col-12 col-md-10">
        <v-card-text class="">
          <p class="mt-4 mb-8" v-html="lastGreeting.note"></p>
          <div class="actions">
            <v-btn
              v-if="
                currentUser.id != lastGreeting.byUserId &&
                !$route.path.includes('demo')
              "
              elevation="0"
              text
              icon
              outlined
              class="report ml-1"
              @click="openDialogReportModal(lastGreeting)"
            >
              <v-icon>mdi-flag</v-icon>
            </v-btn>
            <v-btn
              v-if="currentUser.id == lastGreeting.byUserId"
              elevation="0"
              text
              icon
              outlined
              class="ml-1"
              color="primary"
              @click="editLastGreetingModal(lastGreeting)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="currentUser.id == lastGreeting.byUserId"
              elevation="0"
              text
              icon
              outlined
              class="ml-1"
              color="primary"
              @click="deleteLastGreetingModal(lastGreeting)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "moment";
import helpers from "../../plugins/helpers.js";

export default {
  data() {
    return {
      currentId: null,
    };
  },
  props: {
    currentUser: {
      type: Object,
      default() {
        return {};
      },
    },
    personData: {
      type: Object,
      default() {
        return {};
      },
    },
    lastGreeting: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    getUserInitials(name, lastName) {
      return helpers.getInitials(name, lastName);
    },
    getDate(lastGreeting) {
      return moment(lastGreeting.createdAt).format("lll");
      // return moment(lastGreeting.createdAt).format("DD/MM/YYYY");
    },
    deleteLastGreetingModal(lastGreeting) {
      this.$emit("deleteLastGreetingModal", lastGreeting);
    },
    editLastGreetingModal(lastGreeting) {
      this.$emit("editLastGreetingModal", lastGreeting);
    },
    openDialogReportModal(lastGreeting) {
      this.$emit("openDialogReportModal", lastGreeting);
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.report {
  color: #b4b4b4;
  &:hover {
    color: #b71c1c;
  }
}
.user-profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-top: 0;
  // border: 4px solid #686868;
  background: lightgray;
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
h3 {
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 15px;
  color: #686868;
}
.bb-br-4 {
  border-bottom: 4px solid #e7e7e7;
  border-right: 4px solid #e7e7e7;
}
p {
  font-size: 15px;
  color: #686868;
  &:not(.caption) {
    font-style: italic;
  }
}
</style>